import { Component, EventEmitter, Input, Output, inject } from '@angular/core';

import { NativeAppService, NativeEventType, ViewTemplateForClient } from '@frontend/vanilla/core';
import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

@Component({
    imports: [TrustAsHtmlPipe, IconCustomComponent],
    selector: 'lh-inbox-notification-banner',
    templateUrl: 'inbox-notification-banner.html',
})
export class InboxNotificationBannerComponent {
    private nativeAppService = inject(NativeAppService);

    @Output() onNotificationsTurnedOn: EventEmitter<void> = new EventEmitter<void>();
    @Input() content: ViewTemplateForClient;

    turnOnNotifications() {
        this.onNotificationsTurnedOn.next();
        this.nativeAppService.sendToNative({
            eventName: NativeEventType.OSPrimerSelected,
            parameters: {
                displaySettingsPage: 'Yes',
            },
        });
    }

    close() {
        this.onNotificationsTurnedOn.next();
    }
}
